module.exports = __webpack_public_path__ + "img/login.9c98fe3a.jpg";